import types from "../../actions/documentsActions/types";
import { FETCH_STATUS } from "../../../constants/index";

export const deleteDocumentC = (
    state = {
        data: [],
        status: FETCH_STATUS.NOT_LOADED,
        error: "",
    },
    action
) => {
    const { payload: { data, error } = {} } = action;
    switch (action.type) {
        case types.DELETE_DOCUMENTS_C_REQUEST:
            return {
                ...state,
                status: FETCH_STATUS.LOADING,
                error: null,
            };
        case types.DELETE_DOCUMENTS_C_SUCCESS:
            return {
                ...state,
                data: data,
                status: FETCH_STATUS.LOADED,
            };
        case types.DELETE_DOCUMENTS_C_FAILURE:
            return {
                ...state,
                status: FETCH_STATUS.FAILED,
                error,
            };
        default:
            return state;
    }
};

export default deleteDocumentC;